var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-label-pc"
  }, [_vm.isRequired ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" *  ")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.name) + " ")]);
}
var staticRenderFns = []

export { render, staticRenderFns }